export const IDENTIFIER_TYPE = {
  ISIN: 'isin',
  SEDOL: 'sedol',
  CASH: 'cash',
};
export const DATA_OPTIONS = ['isin', 'sedol', 'cash'];
export const DATA_OPTIONS_WITHOUT_CASH = ['isin', 'sedol'];

export const COLUMN_IDS = {
  TYPE: 'type',
  WEIGHTS: 'weights',
  EXCHANGE: 'exchange',
  ISIN: 'isin',
  SEDOL: 'sedol',
  SHARES: 'shares',
  COVERAGE: 'coverage',
  TICKER: 'ticker',
  ALL_SELECT: 'All select',
  COMPANY_NAME: 'company_name',
  AWF: 'awf',
  IWF: 'iwf',
};

export const HTML_TAG_NAMES = {
  TR: 'TR',
  DIV: 'DIV',
  SELECT: 'SELECT',
  INPUT: 'INPUT',
  TABLE: 'TABLE',
  TEXTAREA: 'TEXTAREA',
};

// Maximum depth for recursive DOM traversal to prevent stack overflow
// 100 levels is more than enough for form wrappers
export const MAX_DEPTH = 100;

const REQUEST_COVERAGE_COLUMNS_UBS = [
  COLUMN_IDS.SEDOL,
  COLUMN_IDS.ISIN,
  COLUMN_IDS.EXCHANGE,
  COLUMN_IDS.COMPANY_NAME,
];

const REQUEST_COVERAGE_COLUMNS_NON_UBS = [
  COLUMN_IDS.ISIN,
  COLUMN_IDS.EXCHANGE,
  COLUMN_IDS.SEDOL,
  COLUMN_IDS.COMPANY_NAME,
];

const REQUEST_COVERAGE_COLUMN_LABELS = {
  [COLUMN_IDS.SEDOL]: 'SEDOL',
  [COLUMN_IDS.ISIN]: 'ISIN',
  [COLUMN_IDS.EXCHANGE]: 'MIC',
  [COLUMN_IDS.COMPANY_NAME]: 'COMPANY NAME',
};

const DATA_LIST_DROPDOWN = [
  { value: 'Long only Basket', id: 'basket', disabled: false },
  // { value: 'Bottom-Up Basket', id: 'global', isDisabled: true },
  { value: 'Long/Short', id: 'long/short', disabled: true },
];

const BASKET_BUTTON_BULK = {
  'Long only Basket': [
    {
      type: 'Button',
      label: 'Submission with Weights',
      url: 'divisor_basket_input_with_open_weight',
    },
    {
      type: 'Button',
      label: 'Submission with Shares',
      url: 'divisor_basket_input_with_shares',
    },
    {
      type: 'Button',
      label: 'Submission with Notionals',
      url: 'divisor_basket_input_with_notional',
    },
  ],
  'Bottom-Up Basket': [{ type: 'Button', label: 'Global Template', url: 'global_input' }],
  'Long/Short': [{ type: 'Button', label: 'Long/short Template', url: 'long_short_input' }],
};

const basketButton = {
  'Long only Basket': [
    {
      type: 'Button',
      label: 'Submission with Weights',
      url: 'divisor_basket_input_with_open_weight',
    },
    {
      type: 'Button',
      label: 'Submission with Shares',
      url: 'divisor_basket_input_with_shares',
    },
    {
      type: 'Button',
      label: 'Submission with Notionals',
      url: 'divisor_basket_input_with_notional',
    },
  ],
  'Bottom-Up Basket': [{ type: 'Button', label: 'Global Template', url: 'global_input' }],
  'Long/Short': [{ type: 'Button', label: 'Long/short Template', url: 'long_short_input' }],
};

const CURRENCIES_ARRAY = [
  'AUD',
  'BRL',
  'CAD',
  'CHF',
  'CLP',
  'CNH',
  'CNY',
  'COP',
  'DKK',
  'EUR',
  'GBP',
  'HKD',
  'ILA',
  'ILS',
  'JPY',
  'KRW',
  'MXN',
  'NGN',
  'NOK',
  'PLN',
  'RON',
  'RUB',
  'SEK',
  'SGD',
  'TRY',
  'TWD',
  'USD',
  'XAG',
  'XAL',
  'XAU',
  'XCU',
  'XNI',
  'XPB',
  'XPD',
  'XPT',
  'XZN',
];

const DAYS_OF_THE_WEEK = {
  0: 'Monday',
  1: 'Tuesday',
  2: 'Wednesday',
  3: 'Thursday',
  4: 'Friday',
  5: 'Saturday',
  6: 'Sunday',
};

const DATA_APPLICATION_POINT = [
  {
    value: 'At Market Close',
    id: 'AT_MARKET_CLOSE',
  },
  {
    value: 'At Market Open',
    id: 'AT_MARKET_OPEN',
  },
];

const DATA_CASH_DISTRIBUTION = [
  {
    value: 'Reinvest distributions across basket',
    id: 'DISTRIBUTION_ACROSS_BASKET',
  },
  {
    value: 'Reinvest distributions on paying security',
    id: 'DISTRIBUTION_ON_PAYING_SECURITY',
  },
  { value: 'Add distributions to cash', id: 'ADD_DISTRIBUTION_TO_CASH' },
];

const DATA_DIVISOR_DETERMINATION_SETUP = [
  { value: 'PREVIOUS EOD', id: 'PREVIOUS_EOD' },
  { value: 'IMMEDIATELY', id: 'IMMEDIATELY' },
];

const DATA_DIVISOR_DETERMINATION_SETUP_VALUES = {
  PREVIOUS_EOD: 'PREVIOUS_EOD',
  IMMEDIATELY: 'IMMEDIATELY',
};

export const PRICE_RETURN = 'PRICE_RETURN';

export const BULK_CALCULATION_TYPE_OPTIONS = [
  { value: 'NET RETURN', id: 'NET_RETURN' },
  { value: 'TOTAL RETURN', id: 'TOTAL_RETURN' },
  { value: 'PRICE RETURN', id: 'PRICE_RETURN' },
];

const HEADERSIZEINITIAL = {
  'All select': 30,
  isin: 160,
  sedol: 90,
  ticker: 90,
  type: 60,
  shares: 150,
  weights: 180,
  awf: 40,
  iwf: 40,
  exchange: 150,
};
const SHARES_DETERMINATION_POINT = {
  IMMEDIATELY: 'IMMEDIATELY',
  PREVIOUS_EOD: 'PREVIOUS EOD',
};

const ORDERED_COLUMNS_WITH_VALID_UBS = [
  'All select',
  'sedol',
  'isin',
  'ticker',
  'company_name',
  'exchange',
  'awf',
  'iwf',
  'status',
];

const ORDERED_COLUMNS_WITHOUT_VALID_UBS = [
  'All select',
  'isin',
  'sedol',
  'ticker',
  'company_name',
  'exchange',
  'awf',
  'iwf',
  'status',
];

const VISIBILITY_INITIAL = {
  'All select': true,
  isin: true,
  awf: false,
  iwf: false,
  shares: true,
  exchange: true,
  sedol: true,
  company_name: true,
  ticker: true,
  weights: true,
  type: true,
};

const DATA_DISSEMINATION = [
  { value: 'BITA Only', id: 'bita_only' },
  { value: 'BITA + Bloomberg', id: 'bita_bloomberg' },
];

const DATA_COUNTRY_CODE_NAMES = {
  AF: 'AFGHANISTAN',
  AL: 'ALBANIA',
  DZ: 'ALGERIA',
  AD: 'ANDORRA',
  AO: 'ANGOLA',
  AI: 'ANGUILLA',
  AQ: 'ANTARCTICA',
  AG: 'ANTIGUA & BARBUDA',
  AR: 'ARGENTINA',
  AM: 'ARMENIA',
  AW: 'ARUBA',
  AU: 'AUSTRALIA',
  AT: 'AUSTRIA',
  AZ: 'AZERBAIJAN',
  AX: 'ALAND ISLANDS',
  BS: 'BAHAMAS',
  BH: 'BAHRAIN',
  BD: 'BANGLADESH',
  BB: 'BARBADOS',
  BY: 'BELARUS',
  BE: 'BELGIUM',
  BZ: 'BELIZE',
  BJ: 'BENIN',
  BM: 'BERMUDA',
  BT: 'BHUTAN',
  BO: 'BOLIVIA',
  BA: 'BOSNIA-HERZE.',
  BW: 'BOTSWANA',
  BV: 'BOUVET ISLAND',
  IO: 'BR.INDN OCEAN',
  BR: 'BRAZIL',
  GB: 'BRITAIN',
  VG: 'BRITISH VIRGIN ISLANDS',
  BN: 'BRUNEI',
  BG: 'BULGARIA',
  BF: 'BURKINA FASO',
  BI: 'BURUNDI',
  BQ: 'BONAIRE, SAINT EUSTATIUS AND SABA',
  KH: 'CAMBODIA',
  CM: 'CAMEROON',
  CA: 'CANADA',
  CV: 'CAPE VERDE',
  KY: 'CAYMAN ISLANDS',
  CF: 'CENTRAL AFRICA',
  TD: 'CHAD',
  CL: 'CHILE',
  CN: 'CHINA',
  CX: 'CHRISTMAS IS.',
  CC: 'COCOS',
  CO: 'COLOMBIA',
  KM: 'COMOROS',
  CG: 'CONGO',
  CK: 'COOK ISLANDS',
  CR: 'COSTA RICA',
  HR: 'CROATIA',
  CU: 'CUBA',
  CW: 'CURACAO',
  CY: 'CYPRUS',
  CZ: 'CZECH',
  CD: 'DEM.REP. CONGO',
  DK: 'DENMARK',
  DJ: 'DJIBOUTI',
  DM: 'DOMINICA',
  DO: 'DOMINICAN REPB.',
  TL: 'EAST TIMOR',
  EC: 'ECUADOR',
  EG: 'EGYPT',
  SV: 'EL SALVADOR',
  GQ: 'EQUATORIAL',
  ER: 'ERITREA',
  EE: 'ESTONIA',
  SZ: 'ESWATINI',
  ET: 'ETHIOPIA',
  FK: 'FALKLAND IS.',
  FO: 'FAROE ISLANDS',
  FJ: 'FIJI',
  FI: 'FINLAND',
  FR: 'FRANCE',
  GF: 'FRENCH GUIANA',
  PF: 'FRENCH PACIFIC',
  TF: 'FRENCH SOUTHERN TERR.',
  GA: 'GABON',
  GM: 'GAMBIA',
  GE: 'GEORGIA',
  DE: 'GERMANY',
  GH: 'GHANA',
  GI: 'GIBRALTAR',
  GR: 'GREECE',
  GL: 'GREENLAND',
  GD: 'GRENADA',
  GP: 'GUADELOUPE',
  GU: 'GUAM',
  GT: 'GUATEMALA',
  GG: 'GUERNSEY',
  GN: 'GUINEA',
  GW: 'GUINEA-BISSAU',
  GY: 'GUYANA',
  HT: 'HAITI',
  HM: 'HEARD/MACDONLD',
  HN: 'HONDURAS',
  HK: 'HONG KONG',
  HU: 'HUNGARY',
  IS: 'ICELAND',
  IN: 'INDIA',
  ID: 'INDONESIA',
  IR: 'IRAN',
  IQ: 'IRAQ',
  IE: 'IRELAND',
  IM: 'ISLE OF MAN',
  IL: 'ISRAEL',
  IT: 'ITALY',
  CI: 'IVORY COAST',
  JM: 'JAMAICA',
  JP: 'JAPAN',
  JE: 'JERSEY',
  JO: 'JORDAN',
  KZ: 'KAZAKHSTAN',
  KE: 'KENYA',
  KI: 'KIRIBATI',
  KW: 'KUWAIT',
  KG: 'KYRGYZSTAN',
  XK: 'KOSOVO',
  LA: 'LAOS',
  LV: 'LATVIA',
  LB: 'LEBANON',
  LS: 'LESOTHO',
  LR: 'LIBERIA',
  LY: 'LIBYA',
  LI: 'LIECHTENSTEIN',
  LT: 'LITHUANIA',
  LU: 'LUXEMBOURG',
  MO: 'MACAU',
  MK: 'MACEDONIA',
  MG: 'MADAGASCAR',
  MW: 'MALAWI',
  MY: 'MALAYSIA',
  MV: 'MALDIVES',
  ML: 'MALI REPUBLIC',
  MT: 'MALTA',
  MH: 'MARSHALL ISLANDS',
  MQ: 'MARTINIQUE',
  MR: 'MAURITANIA',
  MU: 'MAURITIUS',
  YT: 'MAYOTTE',
  MX: 'MEXICO',
  FM: 'MICRONESIA',
  MD: 'MOLDOVA',
  MC: 'MONACO',
  MN: 'MONGOLIA',
  MS: 'MONTSERRAT',
  MA: 'MOROCCO',
  MZ: 'MOZAMBIQUE',
  MM: 'MYANMAR',
  ME: 'MONTENEGRO',
  NA: 'NAMIBIA',
  NR: 'NAURU ISLAND',
  NP: 'NEPAL',
  AN: 'NETH. ANTILLES',
  NL: 'NETHERLANDS',
  NC: 'NEW CALEDONIA',
  NZ: 'NEW ZEALAND',
  NI: 'NICARAGUA',
  NE: 'NIGER REPUBLIC',
  NG: 'NIGERIA',
  NF: 'NORFOLK ISLAND',
  KP: 'NORTH KOREA',
  MP: 'NORTHERN MARIANNA IS.',
  NO: 'NORWAY',
  NU: 'NIUE',
  OM: 'OMAN',
  PK: 'PAKISTAN',
  PW: 'PALAU',
  PS: 'PALESTINE',
  PA: 'PANAMA',
  PZ: 'PANAMA CANAL ZONE',
  PG: 'PAPUA N.GUINEA',
  PY: 'PARAGUAY',
  PE: 'PERU',
  PH: 'PHILIPPINES',
  PN: 'PITCAIRN IS.',
  PL: 'POLAND',
  PT: 'PORTUGAL',
  PR: 'PUERTO RICO',
  QA: 'QATAR',
  RE: 'REUNION',
  RO: 'ROMANIA',
  RU: 'RUSSIA',
  RW: 'RWANDA',
  GS: 'S.GEORGIA/S.SANDWICH',
  AS: 'SAMOA',
  WS: 'SAMOA (WEST)',
  SM: 'SAN MARINO',
  ST: 'SAO TOME',
  SA: 'SAUDI ARABIA',
  ZB: 'SEBORGA',
  SN: 'SENEGAL',
  SC: 'SEYCHELLES',
  SL: 'SIERRA LEONE',
  SG: 'SINGAPORE',
  SK: 'SLOVAKIA',
  SI: 'SLOVENIA',
  SB: 'SOLOMON ISLAND',
  SO: 'SOMALIA',
  ZA: 'SOUTH AFRICA',
  KR: 'SOUTH KOREA',
  SS: 'SOUTH SUDAN',
  ES: 'SPAIN',
  LK: 'SRI LANKA',
  BL: 'ST BARTHELEMY',
  SH: 'ST. HELENA',
  KN: 'ST. KITTS & NEVIS',
  LC: 'ST. LUCIA',
  VC: 'ST. VINCENT',
  SD: 'SUDAN',
  SR: 'SURINAME',
  SJ: 'SVALBARD & JAN MAYEN IS.',
  SE: 'SWEDEN',
  CH: 'SWITZERLAND',
  SY: 'SYRIA',
  RS: 'SERBIA',
  SX: 'SAINT MAARTEN',
  MF: 'ST MARTIN',
  PM: 'ST PIERRE',
  TW: 'TAIWAN',
  TJ: 'TAJIKISTAN',
  TZ: 'TANZANIA',
  TH: 'THAILAND',
  TG: 'TOGO',
  TK: 'TOKELAU',
  TO: 'TONGA',
  TT: 'TRINIDAD AND TOBAGO',
  TN: 'TUNISIA',
  TM: 'TURKMENISTAN',
  TC: 'TURKS & CAICOS',
  TV: 'TUVALU',
  TR: 'TURKIYE',
  UM: 'U.S. MINOR OUTLAYING IS.',
  AE: 'UAE',
  UG: 'UGANDA',
  UA: 'UKRAINE',
  US: 'UNITED STATES',
  UY: 'URUGUAY',
  UZ: 'UZBEKISTAN',
  VU: 'VANUATU',
  VA: 'VATICAN',
  VE: 'VENEZUELA',
  VN: 'VIETNAM',
  VI: 'VIRGIN ISLANDS',
  WF: 'WALLIS & FUTUNA IS.',
  EH: 'WESTERN SAHARA',
  YE: 'YEMEN',
  ZW: 'ZIMBABWE',
  ZM: 'ZAMBIA',
};

const DATA_COUNTRY_CODE = [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AN',
  'AO',
  'AQ',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'PZ',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'SS',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'XK',
  'YE',
  'YT',
  'ZA',
  'ZB',
  'ZM',
  'ZW',
];
const GEOGRAPHICAL_REGION = [
  'NORTH_AMERICA',
  'CENTRAL_EUROPE',
  'EAST_ASIA',
  'WESTERN_EUROPE',
  'SOUTH_ASIA',
  'SOUTH_AMERICA',
  'AUSTRALIA',
  'NORTHERN_EUROPE',
  'EURASIA',
  'EASTERN_EUROPE',
  'AFRICA',
  'MIDDLE_EAST',
  'WEST_ASIA',
  'PACIFIC',
  'WEST_AFRICA',
  'NORTH_AFRICA',
  'EAST_AFRICA',
  'CENTRAL_AMERICA',
  'CARIBBEAN',
  'SOUTHEAST_ASIA',
  'SOUTHERN_EUROPE',
  'SOUTH_AFRICA',
  'GLOBAL',
  'EUROPE',
  'ASIA',
  'LATIN_AMERICA',
  'EUROPE_AND_MIDDLE_EAST',
  'ASIA_PACIFIC',
  'EUROPE_ME_AND_AFRICA',
  'AMERICAS',
  'MIDDLE_EAST_AND_AFRICA',
  'MIDDLE_AFRICA',
  'CENTRAL_ASIA',
  'OCEANIA',
  'MELANESIA',
  'MICRONESIA',
  'POLYNESIA',
];

const GEOGRAPHICAL_REGION_NAMES = GEOGRAPHICAL_REGION.reduce((regionNames, region) => {
  return {
    ...regionNames,
    [region]: region,
  };
}, {});

const BLOOMBERG_GLOBAL_COUNTRY_CODE = 'M1';

const TIMEZONE_OF_TRADING_HOURS = [
  'EASTERN_STANDARD_TIME',
  'CENTRAL_STANDARD_TIME',
  'MOUNTAIN_STANDARD_TIME',
  'PACIFIC_STANDARD_TIME',
  'BRAZIL_TIME',
  'GREENWICH_MEAN_TIME',
  'UNIVERSAL_TIME',
  'CENTRAL_EUROPEAN_TIME',
  'ARABIA_STANDARD_TIME',
  'GULF_STANDARD_TIME',
  'CHINA_STANDARD_TIME',
  'JAPAN_STANDARD_TIME',
  'AUSTRALIA_EASTERN_STANDARD_TIME',
  'INDIA_STANDARD_TIME',
];
const TRADING_DAYS = [
  'MON_TO_FRI',
  'SUN_TO_THU',
  'TUE_TO_SAT',
  'MON_TO_SUN',
  'MON_TO_SAT',
  'MON_IF_NON_DAILY',
  'TUE_IF_NON_DAILY',
  'WED_IF_NON_DAILY',
  'THU_IF_NON_DAILY',
  'FRI_IF_NON_DAILY',
  'SAT_IF_NON_DAILY',
  'SUN_IF_NON_DAILY',
  'OTHER',
];

export {
  DATA_COUNTRY_CODE,
  GEOGRAPHICAL_REGION,
  GEOGRAPHICAL_REGION_NAMES,
  TIMEZONE_OF_TRADING_HOURS,
  TRADING_DAYS,
  HEADERSIZEINITIAL,
  VISIBILITY_INITIAL,
  DATA_DISSEMINATION,
  ORDERED_COLUMNS_WITH_VALID_UBS,
  ORDERED_COLUMNS_WITHOUT_VALID_UBS,
  DATA_LIST_DROPDOWN,
  BASKET_BUTTON_BULK,
  CURRENCIES_ARRAY,
  DAYS_OF_THE_WEEK,
  DATA_APPLICATION_POINT,
  DATA_CASH_DISTRIBUTION,
  DATA_DIVISOR_DETERMINATION_SETUP,
  DATA_DIVISOR_DETERMINATION_SETUP_VALUES,
  DATA_COUNTRY_CODE_NAMES,
  BLOOMBERG_GLOBAL_COUNTRY_CODE,
  SHARES_DETERMINATION_POINT,
  REQUEST_COVERAGE_COLUMNS_UBS,
  REQUEST_COVERAGE_COLUMNS_NON_UBS,
  REQUEST_COVERAGE_COLUMN_LABELS,
};

export const CASH_DISTRIBUTION_OPTIONS = [
  { value: 'Reinvest Distributions Across Basket', id: '3', name: 'DISTRIBUTION_ACROSS_BASKET' },
  {
    value: 'Reinvest Distributions on Paying Security',
    id: '2',
    name: 'DISTRIBUTION_ON_PAYING_SECURITY',
  },
  { value: 'Add Distributions to Cash', id: '1', name: 'ADD_DISTRIBUTION_TO_CASH' },
];

export const APPLICATION_POINT_OPTIONS = [
  { value: 'At Market Close', id: 'AT_MARKET_CLOSE' },
  { value: 'At Market Open', id: 'AT_MARKET_OPEN' },
];
export const CORPORATE_ACTIONS_METHODOLOGY = {
  BITA: 'BITA CORPORATE ACTIONS METHODOLOGY',
  CUSTOM: 'CUSTOM METHODOLOGY',
};

export const CORPORATE_ACTIONS_METHODOLOGY_OPTIONS = [
  CORPORATE_ACTIONS_METHODOLOGY.BITA,
  CORPORATE_ACTIONS_METHODOLOGY.CUSTOM,
];

export const DISSEMINATION_OPTIONS = {
  BITA: 'BITA',
  COMBINED: 'Combined (BITA + Bloomberg)',
};

export const DISSEMINATION_OPTIONS_ARRAY = [
  DISSEMINATION_OPTIONS.BITA,
  DISSEMINATION_OPTIONS.COMBINED,
];

export const BITA_WITHHOLDING_TAX = {
  withholding_tax_name: 'BITA Withholding Taxes',
  id: 'BITA Withholding Taxes', // or 'default' if you want same as first usage
  custom: 'false', // add only if needed universally
  org_id: 'BITA', // optional if always used
};

export const CALCULATION_FREQUENCY_MAPPING = {
  EOD: 'EOD only',
  EOD_INTRADAY: 'EOD and Intraday',
};

export const EXCLUDED_ITEMS = new Set([
  'count_reference_data',
  'count_metadata',
  'identifier_type',
  'divisor_determination_point',
  'exists_cash_constituent',
  'orgPrefix',
]);

export const SUMMARY_BULK_PREVIEW_LABELS = {
  symbol: 'Ticker',
  withholding_tax_id: 'withholding tax template',
  deployment_setup: 'Launch Point',
  calculation_setup: 'Calculation Frequency',
  divisor_determination_setup: 'Divisor Determination Point',
  decrement_value_percentage: 'Annualized Daily Decrement Percentage',
  bloomberg_global: 'Bloomberg Global',
  bloomberg_country_code: 'Bloomberg Country Code',
  bloomberg_geographical_region: 'Bloomberg Geographical Region',
  bloomberg_timezone_of_trading_hours: 'Bloomberg Timezone Of Trading Hours',
  bloomberg_start_time: 'Bloomberg Start Time',
  bloomberg_end_time: 'Bloomberg End Time',
  bloomberg_trading_days: 'Bloomberg Trading Days',
};

export const SHOULD_SHOW_ON_PRODUCTION = false;
export const INITIAL_INPUTS = 'INITIAL_INPUTS';
export const PARAMETERS = 'PARAMETERS';
export const ADDITIONAL_PARAMETERS = 'ADDITIONAL_PARAMETERS';
export const TAB_ORDER = [INITIAL_INPUTS, PARAMETERS, ADDITIONAL_PARAMETERS];
export const PREVIOUS = 'previous';
export const NEXT = 'next';
export const DATA_CALCULATION_TYPE = { IMMEDIATE: 'IMMEDIATE', EOD: 'EOD' };
export const DATA_CALCULATION = [
  { value: 'IMMEDIATE', id: 'IMMEDIATE' },
  { value: 'EOD', id: 'EOD' },
];

export const DATA_CALCULATION_SETUP = [
  { value: 'EOD Only', id: 'EOD' },
  { value: 'EOD and Intra-day', id: 'EOD_INTRADAY' },
];

export const DATA_CALCULATION_SETUP_VALUES = {
  EOD: 'EOD',
  EOD_INTRADAY: 'EOD_INTRADAY',
};

export const MAX_LAUNCH_DATE = new Date('3000-12-12');

export const HEADER_LIST = {
  name: 'Name',
  symbol: 'Ticker',
  currency: 'Currency',
  calculation_type: 'Return Type',
};

export const BASKET_STATUS = {
  CREATED: 'created',
  UPDATED: 'updated',
  ERROR: 'error',
  PENDING: 'pending',
};

export const MESSAGES_ALERT = {
  divisor: `As the divisor was provided by the user, BITACore won't apply any corporate actions from last night.`,
  startingValueImmediatelyLaunchEOD: `The divisor will be calculated using the most recent available market values, including intraday values when available. BITACore will not apply any corporate actions from the previous night.`,
  startingValueImmediatelyLaunchImmediate: `BITACore will immediately begin calculating the basket/index without incorporating any corporate actions from last night.`,
  startingValuePreviousEODLaunchImmediate: `BITACore will apply yesterday's corporate actions, calculate the opening value, and begin intraday calculations. In rare cases, complex corporate actions from the previous day may remain unapplied.`,
};

export const ERROR_MESSAGES_MAP = {
  "'notional'":
    'Shares are missing for one of the constituents. Please check that all values are complete before continuing.',
  "'isin'":
    'One of the constituents is missing an ISIN code. Review the list and add the missing ISIN to continue.',
};

export const TYPE_OF_MODIFICATION = {
  ADDITION: 'Addition',
  UPDATE: 'Update',
  DELETE: 'Delete',
  NO_CHANGE: 'no_change',
  WITH_COVERAGE: 'with_coverage',
  REQUEST_COVERAGE: 'request_coverage',
  NOT_FOUND: 'not_found',
};

export const FIELDS_TO_MODULES_MAP = {
  effective_date: 'Initial Inputs',
  shares: 'Initial Inputs',
  coverage: 'Initial Inputs',
  symbol: 'Parameters',
  name: 'Parameters',
  currency: 'Parameters',
  calculation_setup: 'Parameters',
  calculation_type: 'Parameters',
  calculation_zone: 'Parameters',
  launch_date: 'Parameters',
  launch_point: 'Parameters',
  divisor: 'Parameters',
  starting_value: 'Parameters',
  divisor_determination_setup: 'Parameters',
  interest_rate_on_cash: 'Parameters',
  cash_distribution: 'Additional Parameters',
  cash_distribution_application_point: 'Additional Parameters',
};

export const FIELDS_TO_PROPERTIES_MAP = {
  symbol: 'Symbol',
  name: 'Name',
  currency: 'Currency',
  calculation_setup: 'Calculation Frequency',
  calculation_type: 'Return Type',
  calculation_zone: 'Calculation Zone',
  effective_date: 'Effective Date',
  launch_date: 'Launch Date',
  launch_point: 'Launch Point',
  divisor: 'Divisor',
  starting_value: 'Starting Value',
  divisor_determination_setup: 'Divisor Determination Setup',
  shares: 'Shares',
  cash_distribution: 'Cash Distribution',
  cash_distribution_application_point: 'Application Point',
  interest_rate_on_cash: 'Interest Rate on Cash',
  coverage: 'Coverage',
};

// Reverse mapping from property names to field names
export const PROPERTIES_TO_FIELDS_MAP = Object.fromEntries(
  Object.entries(FIELDS_TO_PROPERTIES_MAP).map(([field, property]) => [property, field]),
);

// Mapping from module names to tab constants
export const MODULE_TO_TAB_MAP = {
  'Initial Inputs': INITIAL_INPUTS,
  Parameters: PARAMETERS,
  'Additional Parameters': ADDITIONAL_PARAMETERS,
};

export const VALIDATION_FIELD_VALUES = {
  divisor_determination_setup: ['PREVIOUS_EOD', 'IMMEDIATELY'],
};

export const MAX_TICKER_LENGTH = 8;

export const CALCULATION_ZONE_CONFIG = {
  CALC_OPEN_TIME: 'rt_start_hour',
  CALC_CLOSE_TIME: 'rt_end_hour',
  CALC_START_WEEK_DAY: 'rt_start_week_day',
  CALC_END_WEEK_DAY: 'rt_end_week_day',
  CALC_EOD_TIME: 'eod_time',
  CALC_TIMEZONE: 'timezone',
};

export const CALCULATION_ZONE_FOR_MARKET_VECTOR = [
  'GLOBAL_EXTENDED',
  'GLOBAL_SUN_TH',
  'GLOBAL_MV',
  'AUSTRALIA_MV',
];

export const EASTERN_APAC_NAME = 'EASTERN_APAC';

export const AT_MARKET_OPEN = 'AT_MARKET_OPEN';

export const CASH_DISTRIBUTION_TYPE_LABEL = 'Cash Distribution Type';
export const CASH_DISTRIBUTION_APPLICATION_POINT_LABEL = 'Cash Distribution Application Point';
